import React, { Fragment, useState, FC } from "react";
import { Popover, Transition } from "@headlessui/react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import DatePicker from "react-datepicker";
import ClearDataButton from "components/HeroSearchForm/ClearDataButton";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import { set } from "lodash";

export interface StayDatesRangeInputViewProps {
  className?: string;
}

const StayDatesRangeInputView: FC<StayDatesRangeInputViewProps> = ({
  className = "flex-1",
}) => {

  const selectedDatesString = sessionStorage.getItem("selected_date") ?? "";

  const [fecha_checkin, fecha_checkout] = selectedDatesString?.split(" - ");


  const today = new Date();
  const checkout = new Date(today);
  checkout.setDate(checkout.getDate() + 3);

  const [startDate, setStartDate] = useState<Date | null>(
    fecha_checkin ? new Date(fecha_checkin.replace(/-/g, "/")) : today
  );

  const [endDate, setEndDate] = useState<Date | null>(
    fecha_checkout ? new Date(fecha_checkout.replace(/-/g, "/")) : checkout
  );


  if (!selectedDatesString) {
    sessionStorage.setItem("start_disp", today.toISOString().split('T')[0]);
    sessionStorage.setItem("end_disp", checkout.toISOString().split('T')[0]);
  } else {
    sessionStorage.setItem("start_disp", fecha_checkin);
    sessionStorage.setItem("end_disp", fecha_checkout);
  }

  const onChangeDate = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    sessionStorage.setItem("selected_date", `${start?.toISOString().split('T')[0]} - ${end?.toISOString().split('T')[0]}`);
    sessionStorage.setItem("start_disp", start?.toISOString().split('T')[0] ?? '');
    sessionStorage.setItem("end_disp", end?.toISOString().split('T')[0] ?? '');
  };

  const renderInput = () => {
    return (
      <>
        <div className="text-neutral-300 dark:text-neutral-400">
          <CalendarIcon className="w-5 h-5 lg:w-7 lg:h-7" />
        </div>
        <div className="flex-grow text-left">
          <span className="block xl:text-lg font-semibold">
          {startDate?.toLocaleDateString("es-AR", {
              month: "short",
              day: "2-digit",
            }) || "Add dates"}
            {endDate
              ? " - " +
              endDate?.toLocaleDateString("es-AR", {
                month: "short",
                day: "2-digit",
              })
              : ""}
          </span>
          <span className="font-semibold">
          {startDate && endDate
              ? `${Math.floor(
                (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
              )} días`
              : "Add dates"}
          </span>
          <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
            {"Check in - Check out"}
          </span>
        </div>
      </>
    );
  };

  return (
    <Popover className={`StayDatesRangeInput z-10 relative flex ${className}`}>
      {({ open = false }) => (
        <>
          <Popover
            id="date-input"
            className={`flex-1 flex relative p-3 items-center space-x-3 focus:outline-none ${open ? "shadow-lg" : ""
              }`}
          >
            {renderInput()}
          </Popover>
        </>
      )}
    </Popover>
  );
};

export default StayDatesRangeInputView;
